/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Metapic Notification API Documentation
 * <p>Welcome to the API documentation for integrating with Metapic's Notification Platform.</p>
        <h2>Authentication</h2>
        <p>This API uses <strong>JWT Bearer</strong> authentication. You must include a valid JWT token in the <strong>Authorization</strong> header as <code>Bearer &lt;token&gt;</code> with every request to access protected endpoints.</p>
        <h4>Example:</h4>
        <pre>Authorization: Bearer <i>jwt_token</i></pre>
        <p>*Replace <i>jwt_token</i> with an actual valid JWT. All API requests require this token for authentication.</p>
 * OpenAPI spec version: 1.0
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
  CreatedMarketingNotificationDto,
  FindAllParams,
  MarketingNotificationDto,
  MarketingNotificationPageDto,
  MarketingNotificationSummaryDto,
  SaveMarketingNotificationDto,
} from '../metapicNotificationAPIDocumentation.schemas'

export const getMarketingNotifications = (axiosInstance: AxiosInstance = axios.default) => {
  const findAll = (
    params?: FindAllParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<MarketingNotificationPageDto>> => {
    return axiosInstance.get(`/marketing-notifications`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  const create = (
    saveMarketingNotificationDto: SaveMarketingNotificationDto,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CreatedMarketingNotificationDto>> => {
    return axiosInstance.post(`/marketing-notifications`, saveMarketingNotificationDto, options)
  }
  const findOne = (
    id: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<MarketingNotificationDto>> => {
    return axiosInstance.get(`/marketing-notifications/${id}`, options)
  }
  const update = (
    id: string,
    saveMarketingNotificationDto: SaveMarketingNotificationDto,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.put(
      `/marketing-notifications/${id}`,
      saveMarketingNotificationDto,
      options,
    )
  }
  const remove = (id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(`/marketing-notifications/${id}`, options)
  }
  const summary = (
    id: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<MarketingNotificationSummaryDto>> => {
    return axiosInstance.get(`/marketing-notifications/${id}/summary`, options)
  }
  return { findAll, create, findOne, update, remove, summary }
}
export type FindAllResult = AxiosResponse<MarketingNotificationPageDto>
export type CreateResult = AxiosResponse<CreatedMarketingNotificationDto>
export type FindOneResult = AxiosResponse<MarketingNotificationDto>
export type UpdateResult = AxiosResponse<void>
export type RemoveResult = AxiosResponse<void>
export type SummaryResult = AxiosResponse<MarketingNotificationSummaryDto>
